import { LockOutlined } from '@ant-design/icons';

export function ChangePasswordPage() {
  return (
    <div className="mobile-card" style={{ textAlign: 'center', padding: 32 }}>
      <LockOutlined style={{ fontSize: 40, color: '#07c160', marginBottom: 16 }} />
      <p style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 600 }}>修改密码</p>
      <p className="mobile-hint" style={{ margin: 0 }}>
        当前版本使用手机号登录，暂未开放自助修改密码。如需调整账号安全设置，请联系系统管理员。
      </p>
    </div>
  );
}
